import z from "zod";
import type { AlertEvent } from "../../types";
import { readLocalStorage, writeLocalStorage } from "../../utils/localStorage";
import { Schemas } from "../../schemas";
import { LS_KEYS } from "../../constants";
import { serviceMapService } from "./serviceMapService";
import { businessServiceService } from "./businessServiceService";

const LS_KEY = "alertEvents" as const;
const schema = Schemas.alertEvent;

const loadAll = async (alertId: string): Promise<AlertEvent[]> =>
  readLocalStorage({
    key: `${LS_KEYS.version}#${LS_KEY}#{${alertId}`,
    schema: z.array(schema),
    d: [],
  });

const saveAll = async (alertId: string, events: AlertEvent[]): Promise<void> =>
  writeLocalStorage({
    key: `${LS_KEYS.version}#${LS_KEY}#{${alertId}`,
    schema: z.array(schema),
    value: events,
  });

export const alertEventsService = {
  create: async (
    alertEvent: Omit<AlertEvent & { count: number }, "id" | "timestamp">,
  ): Promise<void> => {
    const events = await loadAll(alertEvent.alertId);
    for (let i = 0; i < alertEvent.count; i++) {
      const id = (Math.random() * Math.random()).toString();
      events.push(schema.parse({ ...alertEvent, timestamp: Date.now(), id }));
    }
    const services = await businessServiceService.getServicesByAlertId(
      alertEvent.alertId,
    );

    await saveAll(alertEvent.alertId, events);

    const serviceMapIds = Array.from(
      new Set(services.map((service) => service.serviceMapId)),
    );

    for (const serviceMapId of serviceMapIds) {
      await serviceMapService.updateServiceStatuses(serviceMapId);
    }
  },
  list: async (alertId: string): Promise<AlertEvent[]> => {
    return loadAll(alertId);
  },
  clear: async (alertId: string): Promise<void> => {
    await saveAll(alertId, []);
  },
};
